import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	listCard: {
		padding: "16px",
		border: `1px solid ${themeColors.colors.system.gray[200]}`,
		borderRadius: "12px",
		backgroundColor: themeColors.colors.base.white,
		"& th": {
			backgroundColor: themeColors.colors.base.white,
			borderBottom: `1px solid ${themeColors.colors.system.gray[200]}`,
			textTransform: "uppercase",
			fontSize: "0.7rem",
			letterSpacing: "0.05em",
			color: themeColors.colors.system.gray[500],
			fontWeight: 600
		}
	},
	closerCell: {
		display: "inline-flex",
		alignItems: "center",
		gap: "8px"
	},
	closerAvatar: {
		width: "32px",
		height: "32px",
		backgroundColor: themeColors.colors.system.purple[600],
		color: themeColors.colors.base.white,
		fontSize: "0.75rem",
		fontWeight: 700
	},
	userName: {
		fontWeight: 500,
		color: themeColors.colors.system.gray[900]
	},
	dateCell: {
		display: "flex",
		flexDirection: "column"
	},
	datePrimaryRow: {
		display: "flex",
		alignItems: "center",
		gap: "4px"
	},
	datePrimary: {
		color: themeColors.colors.system.gray[900],
		fontWeight: 500
	},
	dateSecondary: {
		fontSize: "0.75rem",
		color: themeColors.colors.system.gray[500],
		whiteSpace: "nowrap"
	},
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: themeColors.colors.system.gray[800]
	},
	scoreCell: {
		display: "inline-flex",
		alignItems: "center",
		gap: "4px",
		padding: "2px 8px",
		borderRadius: "999px",
		height: "24px",
		justifyContent: "center",
		minWidth: "48px"
	},
	scoreDot: {
		width: "6px",
		height: "6px",
		borderRadius: "50%",
		display: "inline-block"
	},
	scoreText: {
		fontWeight: 600,
		fontSize: "0.75rem",
		lineHeight: 1
	},
	profileBadge: {
		backgroundColor: themeColors.colors.base.white,
		color: themeColors.colors.system.gray[900],
		border: `1px solid ${themeColors.colors.system.gray[300]}`,
		borderRadius: "999px",
		fontSize: "0.75rem",
		fontWeight: 700,
		height: "24px"
	},
	objectionBadge: {
		backgroundColor: themeColors.colors.system.beige[100],
		color: themeColors.colors.system.beige[800],
		borderRadius: "999px",
		fontSize: "0.75rem",
		fontWeight: 500,
		height: "24px"
	},
	leadName: {
		fontWeight: 600,
		color: themeColors.colors.system.gray[900]
	},
	leadCompany: {
		fontSize: "0.75rem",
		color: themeColors.colors.system.gray[500]
	},
	editIconButton: {
		padding: "2px"
	},
	conversionText: {
		fontWeight: 600,
		color: themeColors.colors.system.gray[900]
	},
	clickableRow: {
		cursor: "pointer",
		transition: "background-color 0.15s ease",
		"&:hover": {
			backgroundColor: themeColors.colors.system.gray[50]
		}
	},
	emptyState: {
		padding: "48px 16px",
		textAlign: "center"
	},
	emptyStateTitle: {
		fontSize: "1.125rem",
		fontWeight: 600,
		color: themeColors.colors.system.gray[700],
		marginBottom: "8px"
	},
	emptyStateSubtitle: {
		fontSize: "0.875rem",
		color: themeColors.colors.system.gray[500]
	},
	searchButton: {
		height: "55px"
	}
}))

export default useStyles
